import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './i18n';

import { Main } from './components/Main';

import '@artstorefronts/ui/dist/index.css';
import './index.css';
import { ROOT_ELEMEMT_ID } from './consts';

createRoot(document.getElementById(ROOT_ELEMEMT_ID)!).render(
  <StrictMode>
    <Main />
  </StrictMode>
);
